import React, { Component } from "react";

export default class CubeCountingSection extends Component {
  render() {
    var {
      cube_countring_score,
      cube_status_1,
      cube_status_2,
      cube_status_3,
      cube_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark cube_counting_section">
        <div className="col-lg-12">
          <div className="row mt-5">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6 mb-3">
              <p className="mb-0" style={{fontSize: 17, listStyle: "circle"}}>
                <b>1)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/cube-images/1.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6 mb-3">
              <p className="mb-0" style={{fontSize: 17, listStyle: "circle"}}>
                <b>2)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/cube-images/2.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p className="mb-0" style={{fontSize: 17, listStyle: "circle"}}>
                <b>3)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/cube-images/3.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p className="mb-0" style={{fontSize: 17, listStyle: "circle"}}>
                <b>4)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas-form/cube-images/4.png"}
                  alt="scorpion"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <br />
            <span className="fs-18">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="cube_countring_score"
              value={cube_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
